import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useIsMobile from 'hooks/screen/useIsMobile';

const TooltipTypes = {
  Error: 'error',
  Info: 'info',
};

const Tooltip = ({ children, open, placement, title, type }) => {
  const theme = useTheme();
  const isMobile = useIsMobile({ tablet: true });

  const arrowColor = type === TooltipTypes.Error ? theme.palette.error.main : theme.palette.secondary.main;
  const tooltipColor = type === TooltipTypes.Error ? theme.palette.error.main : theme.palette.secondary.main;

  return (
    <MuiTooltip
      arrow
      open={open}
      placement={isMobile ? 'bottom' : placement}
      title={title}
      sx={{
        '& .MuiTooltip-arrow': {
          color: arrowColor,
        },
        '& .MuiTooltip-tooltip': {
          backgroundColor: tooltipColor,
        },
        '& .MuiTooltip-tooltipPlacementBottom': {
          top: '-12px',
        },
        '& .MuiTooltip-tooltipPlacementLeft': {
          margin: '0 4px',
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf([TooltipTypes.Error, TooltipTypes.Info]),
};

Tooltip.defaultProps = {
  placement: 'left',
  type: TooltipTypes.Info,
  title: '',
};

export default Tooltip;
